import React from 'react';

const SectionButton = ({ title, subtitle, icon, className = '', onClick }) => {
   return (
    <div
      onClick={onClick}
      className={`bg-brand-beige p-5 shadow-md hover:shadow-lg rounded-lg
                  border border-brand-border hover:bg-gray-50
                  transition-all duration-300 ease-in-out transform hover:-translate-y-1
                  flex flex-col justify-between items-center min-h-[140px] text-center group ${onClick ? 'cursor-pointer' : ''} ${className}`}
    >
      <div>
        {icon && <div className="text-3xl mb-2 text-brand-text-dark group-hover:text-brand-dark-green transition-colors duration-300">{icon}</div>}
        <h2 className="text-xl font-serif font-bold mb-1 text-brand-text-dark group-hover:text-brand-dark-green transition-colors duration-300">{title}</h2>
      </div>
      {subtitle && <p className="text-sm font-sans text-gray-700 mt-2 px-2">{subtitle}</p>}
    </div>
  );
};

export default SectionButton;